import { render, staticRenderFns } from "./TeamTypeCreateEdit.vue?vue&type=template&id=5deae6f6&scoped=true"
import script from "./TeamTypeCreateEdit.vue?vue&type=script&lang=js"
export * from "./TeamTypeCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./TeamTypeCreateEdit.vue?vue&type=style&index=0&id=5deae6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deae6f6",
  null
  
)

export default component.exports